<template>
  <div>
    <div class="tw-flex tw-flex-start tw-justify-between">
      <p
        class="tw-mx-4 tw-block tw-text-eko-orange tw-mt-8 tw-font-bold tw-text-2xl"
      >
        Your Payments
      </p>
    </div>
    <table
      class="tw-table-auto tw-mx-1 tw-mr-2 tw-mb-12 tw-w-full tw-text-left"
    >
      <thead>
        <tr class="tw-bg-eko-light tw-text-white">
          <th class="tw-border tw-px-4 tw-py-2">Title</th>
          <th class="tw-border tw-px-4 tw-py-2">Author</th>
          <th class="tw-border tw-px-4 tw-py-2">Views</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="i in 12"
          :key="i"
          :class="i % 2 == 0 ? 'tw-bg-gray-300' : ''"
        >
          <td class="tw-border tw-px-4 tw-py-2">Intro to CSS</td>
          <td class="tw-border tw-px-4 tw-py-2">Adam</td>
          <td class="tw-border tw-px-4 tw-py-2">858</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped></style>
